import { MunicipioResponse } from "../../types/generalInfo";
import { apiSlice } from "../../lib/baseQuery";

const BASE_URL = "/api/generalinfo";

export const generalInfoAPi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMunicipios: builder.query<MunicipioResponse[], void>({
            query: () => BASE_URL + "/municipios",
        })
    })
});

export const {
    useGetMunicipiosQuery,
} = generalInfoAPi;